
























/* Created- 16 - May - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { CurationTodoDTO } from "../../Generated/ParticaAPI";
import { eParticaAction, ParticaEvent } from "../../Models/ParticaEvent";
@Component(
	{
		name: "ContentStreamTodoList"
	})
export default class ContentStreamTodoList extends Vue {
	@Prop() private todolist: CurationTodoDTO[];
	private search: string = "";
	private headers: any = [
		{
			text: "Stream",
			align: "left",
			sortable: true,
			value: "stream"
		},
		{ text: "Level", value: "level", sortable: true, },
		{ text: "Subscriber", value: "subscriber", sortable: true, },
		{ text: "Issue", value: "issue", sortable: true, },
		{ text: "Title", value: "title", sortable: true, align: "left" },
		{ text: "Waiting since", value: "finalizedTime", sortable: true, align: "left" },
	];

	private curate(item: CurationTodoDTO) {
		this.$emit("partica-event", { action: eParticaAction.CONTENT_STREAM_CURATE_ARTICLE, item } as ParticaEvent);
	}
}
